import React from 'react';
import type { ReadyItem } from '../../api/plan';
import { INTERFACE_TEXT } from '../../constants/interfaceText';
import {
  KIND_LABEL,
  fill,
  itemTitle,
  reasonText,
} from '../../today/todayViewModel';
import styles from './TodayScreen.module.css';

interface UpNextProps {
  item: ReadyItem;
  blurb: string;
  onStart: (item: ReadyItem) => void;
}

/** The one next step, with the reason it was chosen. */
export const UpNext: React.FC<UpNextProps> = ({ item, blurb, onStart }) => (
  <section
    className={`${styles.next} ${item.kind === 'check_in' ? styles.nextCheck : ''}`}
    aria-labelledby="up-next-title"
  >
    <span className={styles.kind}>
      {INTERFACE_TEXT.tdUpNext} · {KIND_LABEL[item.kind]}
    </span>
    <h2 id="up-next-title" className={styles.nextTitle}>
      {itemTitle(item)}
    </h2>
    <p className={styles.why}>{reasonText(item, blurb)}</p>
    <button type="button" className={styles.go} onClick={() => onStart(item)}>
      {INTERFACE_TEXT.tdStart}
      <span>{fill(INTERFACE_TEXT.tdMinutes, { n: item.minutes })}</span>
    </button>
  </section>
);

interface AlsoReadyProps {
  items: ReadyItem[];
  onStart: (item: ReadyItem) => void;
}

const KIND_LETTER: Record<ReadyItem['kind'], string> = {
  lesson: 'L',
  check_in: 'C',
  review: 'R',
};

/** A short list of other things that are ready. */
export const AlsoReady: React.FC<AlsoReadyProps> = ({ items, onStart }) => {
  if (items.length === 0) return null;
  return (
    <section className={styles.also} aria-labelledby="also-ready-title">
      <h2 id="also-ready-title" className={styles.eyebrow}>
        {INTERFACE_TEXT.tdAlsoReady}
      </h2>
      <ul className={styles.alsoList}>
        {items.map((item, index) => (
          <li key={`${item.kind}-${item.context_id ?? 'review'}-${index}`}>
            <button
              type="button"
              className={styles.card}
              onClick={() => onStart(item)}
            >
              <span
                className={`${styles.icon} ${styles[`icon_${item.kind}`]}`}
                aria-hidden="true"
              >
                {KIND_LETTER[item.kind]}
              </span>
              <span>
                <b>{itemTitle(item)}</b>
                <small>{KIND_LABEL[item.kind]}</small>
              </span>
              <span className={styles.min}>
                {fill(INTERFACE_TEXT.tdMinutes, { n: item.minutes })}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
